
import { Grid, Tabs, Tab } from "@mui/material";
import React from "react";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { useRecoilValue } from "recoil";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { Link, Route, Switch } from "react-router-dom";
import { useRouteMatch } from "../../../Helpers/RouteMatcher";
import { Remuneration } from "./Remuneration/Remuneration";
import { AverageAndMedianRemuneration } from "./AverageAndMedianRemuneration/AverageAndMedianRemuneration";

export const EEA4Base = () => {
    const scorecard = useRecoilValue(ScorecardAtom);

    const routes = [
        "/ee/scorecard/" + scorecard.scorecardId + "/remuneration/Remuneration",
        "/ee/scorecard/" + scorecard.scorecardId + "/remuneration/MedianRemunerationAndRemunerationGap",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    return (

        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Remuneration (EEA4)
                </MDTypography>
            </MDBox>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Remuneration" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Median Remuneration And the Remuneration Gap" value={routes[1]} to={routes[1]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        <Route path={routes[0]}>
                            <Remuneration scorecardId={scorecard.scorecardId} />
                        </Route>
                        <Route path={routes[1]}>
                            <AverageAndMedianRemuneration scorecardId={scorecard.scorecardId} />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}